// fr strings for messages/train.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const train: Dict = {
  "train.seo.title": "Entraîne ta voix IA personnalisée | Jammable",
  "train.seo.description":
    "Entraîne tes propres voix IA personnalisées sur Jammable. Importe des fichiers audio, entraîne un modèle de voix et partage-le avec la communauté ou garde-le privé.",
  "train.h1": "Entraîner une voix",
  "train.sub":
    "Quelques minutes de chant ou de parole bien propres, et tu obtiens une voix à utiliser dans tes covers.",
  "train.voicesTrained": "{count} voix entraînées",

  "train.faq.title": "Questions fréquentes",
  "train.faq.dataset.q": "Qu'est-ce qu'un dataset ?",
  "train.faq.dataset.a1": "Un ensemble de fichiers audio contenant de la voix.",
  "train.faq.dataset.a2":
    "Au moins {min} minutes de chant ou de parole, idéalement plus de 10.",
  "train.faq.dataset.a3": "Au format MP3, WAV ou M4A.",
  "train.faq.private.q": "Ma voix personnalisée sera-t-elle privée ?",
  "train.faq.private.a":
    "Oui ! Si tu choisis de la garder privée, tu seras le seul à pouvoir accéder à ton modèle de voix, le voir et l'utiliser !",
  "train.faq.time.q": "Combien de temps prend l'entraînement de ma voix ?",
  "train.faq.time.a":
    "Ça dépend de la quantité d'audio : en général {short} pour 10 minutes d'audio, {long} pour une heure. Tu peux fermer la page, on t'envoie un e-mail quand c'est prêt.",

  "train.eta.minutes": "environ {m} minutes",
  "train.eta.hour": "environ {h} heure",
  "train.eta.hours": "environ {h} heures",
  "train.eta.hourMinutes": "environ {h} heure {m} minutes",
  "train.eta.hoursMinutes": "environ {h} heures {m} minutes",
  "train.minutes": "{n} minutes",

  "train.samples": "Échantillons",
  "train.filesOne": "1 fichier · {time}",
  "train.filesMany": "{n} fichiers · {time}",
  "train.passesLeft": "Entraînements restants",
  "train.unlimited": "Illimité",
  "train.nameIt": "Nomme-la",
  "train.creatorShort": "L'entraînement est inclus dans Creator.",

  "train.upload.invalidType": "Type de fichier non valide.",
  "train.upload.skippedOne":
    "{names} ignoré : déjà ajouté. Le même audio en double n'aide pas ta voix, il ne compte qu'une fois.",
  "train.upload.skippedMany":
    "{names} ignorés : déjà ajoutés. Le même audio en double n'aide pas ta voix, il ne compte qu'une fois.",
  "train.upload.nFiles": "{n} fichiers",
  "train.upload.someInvalid": "Un ou plusieurs fichiers ne sont pas valides.",
  "train.upload.failed": "Échec de l'import",
  "train.upload.needsPlan": "Un abonnement est nécessaire pour importer",
  "train.upload.tooManyLabel": "Trop d'imports en ce moment, réessaie bientôt",
  "train.upload.tooManyToast":
    "Trop d'imports en ce moment. Réessaie dans quelques minutes.",
  "train.upload.analysing":
    "On repère encore les silences dans tes fichiers. Un instant.",
  "train.upload.blocked":
    "Certains fichiers sont bloqués. Retire-les pour continuer.",
  "train.upload.errored":
    "Certains fichiers contiennent des erreurs. Retire-les pour continuer.",
  "train.upload.processing":
    "Certains fichiers sont encore en traitement. Attends qu'ils soient prêts.",
  "train.upload.tooShort":
    "Il te faut {min} de chant ou de parole, sans les silences. Tu as {have}.",
  "train.upload.tooLong":
    "{max} d'audio maximum. Tu as {have} : retire un fichier ou coupe un passage.",
  "train.upload.title": "Ajoute ta voix",
  "train.upload.ofMin": "sur {min}",
  "train.upload.overLimit": "{over} au-delà de la limite de {n} minutes",
  "train.upload.ready": "Prêt ✓",
  "train.upload.addMore": "Ajoute encore {left}",
  "train.upload.short":
    "Les voix sonnent généralement mieux avec {n} minutes ou plus. Tu peux lancer l'entraînement maintenant, ou ajouter encore {left} si tu en as.",
  "train.upload.uploadFiles": "Importer des fichiers",
  "train.upload.record": "Enregistrer",
  "train.upload.addIt": "Ajouter",
  "train.upload.recordHint":
    "Chante ou parle. Enregistre autant de prises que tu veux.",
  "train.upload.blockedFrom": "Bloqué - contenu de {label}",
  "train.upload.gettingReady": "Préparation...",
  "train.upload.ofVoice": "{time} de voix",
  "train.upload.removed": "{time} en moins",
  "train.upload.uploading": "import en cours...",
  "train.upload.done": "OK",
  "train.upload.trim": "Couper",
  "train.upload.retry": "Réessayer",
  "train.upload.remove": "Retirer {name}",
  "train.upload.silenceNote":
    "Les silences sont retirés pour toi. En violet : ce dont ta voix apprend.",
  "train.upload.tip1.title": "Une seule voix",
  "train.upload.tip1.sub": "Pas de choristes ni de public",
  "train.upload.tip2.title": "Pièce calme",
  "train.upload.tip2.sub": "Pas d'écho, pas de bruit de fond",
  "train.upload.tip3.title": "Plus il y en a, mieux c'est",
  "train.upload.tip3.sub": "Des notes et des mots variés",
  "train.upload.nextHint":
    "Ensuite : un nom, une image et qui peut l'utiliser.",
  "train.upload.cardTitle": "Tes échantillons",
  "train.upload.footnote":
    "Au moins {min} de chant ou de parole ({rec} ou plus, c'est mieux), jusqu'à {max}. Les silences et les fichiers en double ne comptent pas ; les silences sont coupés pour toi.",
  "train.upload.footnoteNoRec":
    "Au moins {min} de chant ou de parole, jusqu'à {max}. Les silences et les fichiers en double ne comptent pas ; les silences sont coupés pour toi.",
  "train.upload.creatorNote":
    "L'entraînement est inclus dans Creator. Importe d'abord ta voix et décide à la fin ; tu verras le prix avant de payer.",
  "train.upload.continue": "Continuer",

  "train.sample.play": "Écouter {label}",
  "train.sample.pause": "Mettre {label} en pause",
  "train.clip.keptOf": "conservé sur {total}",
  "train.clip.silenceCut": "{time} de silence coupé",
  "train.clip.cutByYou": "{time} coupé par toi",
  "train.clip.cut": "coupé",
  "train.clip.play": "Lecture",
  "train.clip.stop": "Stop",
  "train.clip.keepIt": "Garder",
  "train.clip.cutIt": "Couper",
  "train.clip.cancel": "Annuler",
  "train.clip.hint":
    "Fais glisser sur le passage dont tu ne veux pas, puis coupe-le. Touche pour écouter.",
  "train.clip.undo": "Annuler mes coupes",

  "train.info.samplesAdded": "Échantillons ajoutés",
  "train.info.edit": "Modifier",
  "train.info.namePlaceholder": "Nom de la voix, ex. : Ma voix",
  "train.info.descPlaceholder":
    "Description - explique à la communauté comment la voix a été entraînée...",
  "train.info.whoCanUse": "Qui peut l'utiliser",
  "train.info.private": "Privée, moi seulement",
  "train.info.public": "Publique dans la bibliothèque",
  "train.info.cleanUp": "Nettoyer les échantillons",
  "train.info.removeInstrumentals": "Retirer les instrumentaux",
  "train.info.removeInstrumentalsSub":
    "Retire tout ce qui n'est pas de la voix dans le dataset.",
  "train.info.removeReverb": "Retirer la réverbération",
  "train.info.removeReverbSub":
    "Retire la réverbération de tous les audios du dataset.",
  "train.info.cardTitle": "Prête à entraîner",
  "train.info.usuallyReadyIn": "Généralement prête en",
  "train.info.upTo2h": "Jusqu'à 2 heures",
  "train.info.closePage":
    "L'entraînement tourne de notre côté, tu peux fermer la page.",
  "train.info.starting": "Lancement...",
  "train.info.start": "Lancer l'entraînement",
  "train.info.orGetPass": "Ou prends un pass d'entraînement",
  "train.info.getMorePasses": "Obtenir plus de pass d'entraînement",
  "train.info.usesOnePass": "Utilise 1 pass d'entraînement",
  "train.info.started": "Entraînement lancé",
  "train.info.onCreator": "Tu as Creator. Lancement de ton entraînement...",
  "train.info.legal":
    "En continuant, tu donnes à Jammable le droit d'utiliser le contenu que tu importes et tu CONFIRMES QUE CE CONTENU T'APPARTIENT ET NE CONTIENT AUCUN ÉLÉMENT PROTÉGÉ PAR LES DROITS D'AUTEUR DE TIERS.",
  "train.info.agreeTerms": "Accepte nos conditions d'utilisation !",
  "train.info.chooseName": "Choisis un nom pour ta voix !",
  "train.info.uploadImage": "Importe une image !",
  "train.info.invalidName":
    "Nom de modèle non valide. Pas de caractères spéciaux",
  "train.info.signIn": "Tu dois être connecté",
  "train.info.errorStarting": "Erreur au lancement de l'entraînement",
  "train.info.errorSignedUrl": "Erreur lors de l'obtention de l'URL signée",

  "train.demo.title": "Écoute une voix entraînée",
  "train.demo.by": "Par un utilisateur Power de Jammable",
  "train.demo.data.label": "Données d'entraînement",
  "train.demo.data.note": "Quelques minutes d'une voix",
  "train.demo.input.label": "Titre d'entrée",
  "train.demo.input.note": "Le titre qu'elle va chanter",
  "train.demo.output.label": "Résultat final",
  "train.demo.output.note": "Chanté avec la voix entraînée",
  "train.demo.play": "Écouter {label}",
  "train.demo.pause": "Mettre {label} en pause",

  "train.retry.trainAgain": "Réentraîner",
  "train.retry.tryAgain": "Réessayer",
  "train.retry.orNewSamples": "Ou entraîne-la avec de nouveaux échantillons",
  "train.retry.retrying":
    "Nouvel entraînement en cours. On t'envoie un e-mail quand c'est prêt.",
  "train.retry.couldntStart": "Impossible de lancer l'entraînement. Réessaie.",
  "train.retry.confirmUnlimited":
    "On va la réentraîner avec les mêmes échantillons. Inclus dans ton abonnement.",
  "train.retry.confirmOutCreator":
    "Réessayer utilise un pass d'entraînement, et tu n'en as plus. L'entraînement est inclus dans Creator.",
  "train.retry.confirmOut":
    "Réessayer utilise un pass d'entraînement, et tu n'en as plus.",
  "train.retry.confirmPass":
    "On va la réentraîner avec les mêmes échantillons. Utilise 1 pass d'entraînement (tu en as {passes}) ; si ça échoue encore, il t'est rendu.",
  "train.retry.cancel": "Annuler",
  "train.retry.seeCreator": "Voir Creator",
  "train.retry.getPass": "Prendre un pass d'entraînement",
  "train.retry.orGetPass": "Ou prends un pass d'entraînement",
  "train.retry.starting": "Lancement...",
  "train.retry.usePass": "Utiliser un pass et réessayer",
  "train.retry.refuse.cleanVocals":
    "Réessayer échouerait de la même façon. Réentraîne-la avec une voix propre : sans musique, sans longs silences.",
  "train.retry.refuse.formats":
    "Réessayer échouerait de la même façon. Réentraîne-la avec des fichiers MP3, WAV ou M4A de chant ou de parole bien nets.",
  "train.retry.refuse.newSamples":
    "Réessayer échouerait de la même façon. Réentraîne-la avec de nouveaux échantillons.",
  "train.retry.refuse.saveAs":
    "Réessayer échouerait de la même façon. Enregistre tes fichiers en MP3 ou WAV et réentraîne-la.",
  "train.retry.refuse.filesMissing":
    "Réentraîne-la avec de nouveaux échantillons.",
  "train.retry.refuse.retryCap":
    "Cette voix a déjà été tentée {n} fois. Réentraîne-la, idéalement avec d'autres échantillons.",

  "train.final.confirm": "Confirmer",
  "train.final.back": "Retour",
  "train.final.next": "Suivant",
};

export default train;
